import createAxios from '@/app/core/AxiosCore';
import config from '@/app/config/app';

const axios = createAxios(config);

function listarNbs(params = {}) {
  return axios.get('notasfiscais/classificacao-tributaria/nbs', { params })
    .then(response => response.data);
}

function listarIndop(params = {}) {
  return axios.get('notasfiscais/classificacao-tributaria/indop', { params })
    .then(response => response.data);
}

function listarCst(params = {}) {
  return axios.get('notasfiscais/classificacao-tributaria/cst', { params })
    .then(response => response.data);
}

function listarClassificacoes(params = {}) {
  return axios.get('notasfiscais/classificacao-tributaria/cclass-trib', { params })
    .then(response => response.data);
}

export default {
  listarNbs,
  listarIndop,
  listarCst,
  listarClassificacoes,
}